<template>
    <div>
        <div class="row" v-if="isUpdateAlertVisible && !hideVersionDetails">
            <div class="col">
                <div class="alert alert-primary">
                    <span v-html="translate('messages.versionText:'+version)"></span>
                    <router-link :to="{ name: 'Updates' }" class="alert-link">{{translate('messages.checkNewFeatures')}}</router-link>
                    <!-- <button @click="closeUpdateAlert" type="button" class="close" title="Kapat" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button> -->
                </div>
            </div>
        </div>
        <div class="row" v-if="isUserFormAlertVisible">
            <div class="col">
                <div class="alert alert-warning">
                    <h4>{{translate('dashboard.important')}}</h4>
                    <router-link :to="{ name: 'UserIdentity', params: { id: userId } }" class="btn btn-warning float-right">{{translate('dashboard.completeNow')}}</router-link>
                    <p>
                        {{translate('warnings.identityInfoMissing')}}
                        <span v-show="this.hasAuth('Signer')">
                            {{translate('warnings.identityInfoRequiredToSign')}}
                        </span>
                    </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="roundbox">
                    <div class="rbcontent" style="padding-bottom:20px;">
                        <h4>{{translate('dashboard.myJobs')}}</h4>
                        <table class="table table-hover badge-table clickable" v-if="myStats">
                            <tbody>
                                <tr @click="$router.push({ name: 'JobMyList', hash: '#MyWaiting' })">
                                    <td><span class="badge badge-primary">{{myStats.Waiting}}</span></td>
                                    <td>{{translate('dashboard.signatureOrApprovalWaiting')}}</td>
                                </tr>
                                <tr v-show="hasModule('REM')" @click="$router.push({ name: 'RemList' })">
                                    <td><span class="badge badge-info">{{myStats.Rem}}</span></td>
                                    <td>{{translate('dashboard.kepWaiting')}}</td>
                                </tr>
                                <tr @click="$router.push({ name: 'JobMyList', hash: '#MyOwned'  })">
                                    <td><span class="badge badge-dark">{{myStats.Owned}}</span></td>
                                    <td>{{translate('dashboard.myStartedJobs')}}</td>
                                </tr>
                                <tr @click="$router.push({ name: 'JobMyList', hash: '#MyApproved' })">
                                    <td><span class="badge badge-success">{{myStats.Approved}}</span></td>
                                    <td>{{translate('dashboard.mySignedApproved')}}</td>
                                </tr>
                                <tr @click="$router.push({ name: 'JobMyList', hash: '#MyDeclined' })">
                                    <td><span class="badge badge-danger">{{myStats.Declined}}</span></td>
                                    <td>{{translate('dashboard.myDeclined')}}</td>
                                </tr>
                                <tr @click="$router.push({ name: 'JobMyList', hash: '#MyCanceled' })">
                                    <td><span class="badge badge-warning">{{myStats.Canceled}}</span></td>
                                    <td>{{translate('dashboard.myCancelled')}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-else-if="myStatsError" class="text-center text-danger">
                            {{myStatsError}}
                        </div>
                        <div v-else class="text-center text-muted">
                            {{translate('loading')}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="roundbox" v-if="hasAuth('Report')">
                    <div class="rbcontent" style="padding-bottom:20px;">
                        <h4>{{translate('dashboard.jobs')}}</h4>
                        <table class="table table-hover badge-table clickable" v-if="stats">
                            <tbody>
                                <tr @click="$router.push({ name: 'JobList', hash: '#Circulating' })">
                                    <td><span class="badge badge-primary">{{stats.Circulating}}</span></td>
                                    <td>{{translate('dashboard.circulating')}}</td>
                                </tr>
                                <tr @click="$router.push({ name: 'JobList', hash: '#Completed' })">
                                    <td><span class="badge badge-success">{{stats.Completed}}</span></td>
                                    <td>{{translate('dashboard.completed')}}</td>
                                </tr>
                                <tr @click="$router.push({ name: 'JobList', hash: '#Finalizing' })">
                                    <td><span class="badge badge-info">{{stats.Finalizing}}</span></td>
                                    <td>{{translate('dashboard.finalizing')}}</td>
                                </tr>
                                <tr @click="$router.push({ name: 'JobList', hash: '#Declined' })">
                                    <td><span class="badge badge-danger">{{stats.Declined}}</span></td>
                                    <td>{{translate('dashboard.declined')}}</td>
                                </tr>
                                <tr @click="$router.push({ name: 'JobList', hash: '#Canceled' })">
                                    <td><span class="badge badge-warning">{{stats.Canceled}}</span></td>
                                    <td>{{translate('dashboard.cancelled')}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-else-if="myStatsError" class="text-center text-danger">
                            {{myStatsError}}
                        </div>
                        <div v-else class="text-center text-muted">
                            {{translate('loading')}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import userImport from '../components/UserImport'
import axios from 'axios'

export default {
    components: {
        // userImport
    },
    data(){
        return {
            myStats: null,
            myStatsError: null,
            stats: null,
            statsError: null,
            version: process.env.VUE_APP_VERSION,
            closedVersion: localStorage.version
        };
    },
    methods:{
        getMyStats(){
            this.myStats = null;
            this.myStatsError = null;

            axios.get('/dashboard/myjobs')
            .then(r => {
                this.myStats = r.data;
            })
            .catch(r => {
                console.log("MyStatsErr:", r);
                this.myStatsError = this.translate('errors.couldntLoad');
            });
        },
        getStats(){
            this.stats = null;
            this.statsError = null;

            if(!this.hasAuth("Report") && !this.hasAuth("Admin"))
                return;

            axios.get('/dashboard/jobManagement')
            .then(r => {
                this.stats = r.data;
            })
            .catch(r => {
                console.log("StatsErr:", r);
                this.statsError =  this.translate('errors.couldntLoad');

                if(r.response.data.ModelState?.InvalidTokenException) {
                    window.processErrorResponse(r, this)
                }
            });
        },
        closeUpdateAlert(){
            localStorage.version = process.env.VUE_APP_VERSION;
            this.closedVersion = localStorage.version;
        }
    },
    created(){
        this.getMyStats();
        this.getStats();
    },
    computed: {
        isUpdateAlertVisible(){
            return this.closedVersion != this.version;
        },
        isUserFormAlertVisible(){
            var user = this.$root.$data.login.User;
            console.log('isUserFormAlertVisible: ', user);

            if(this.hasAuth("Signer") || this.$root.$data.login.Account.Params.IsIdentityNumberRequiredForInternalUser)
            {
                if(this.$root.$data.login.Account.Params.VerifyIdentityDataFromGovService)
                    return !user.IdentityNumber || !user.BirthDate;
                else
                    return !user.IdentityNumber
            }

            return false;
        },
        userId(){
            return this.$root.$data.login.User.Id;
        },
        hideVersionDetails(){
            if(this.hasAuth("Admin"))
                return false;
            else
                return window.settings.customization.hideVersionDetails ? true : false;  
        }
    }
}
</script>
<style scoped>
table.clickable tbody tr {
    cursor: pointer;
}

table.badge-table tbody tr td {
    vertical-align: middle;
    font-size: 1.1rem;
}

table.badge-table tbody tr > td:first-child {
    text-align: center;
    width:1%;
    font-size: 1.4rem;
}
</style>